/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Side_HintInputs */

const en_us2_workout_logging_side_hint = /** @type {(inputs: Workout_Logging_Side_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On a one-sided exercise, log each side as its own set.`)
};

const pt_br2_workout_logging_side_hint = /** @type {(inputs: Workout_Logging_Side_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em exercício unilateral, registre cada lado como uma série.`)
};

const es_419_workout_logging_side_hint = /** @type {(inputs: Workout_Logging_Side_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En un ejercicio unilateral, registra cada lado como una serie.`)
};

const pt_pt2_workout_logging_side_hint = /** @type {(inputs: Workout_Logging_Side_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Num exercício unilateral, regista cada lado como uma série.`)
};

const fr_fr2_workout_logging_side_hint = /** @type {(inputs: Workout_Logging_Side_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sur un exercice unilatéral, note chaque côté comme une série à part.`)
};

const de_de2_workout_logging_side_hint = /** @type {(inputs: Workout_Logging_Side_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei einseitigen Übungen trägst du jede Seite als eigenen Satz ein.`)
};

const it_it2_workout_logging_side_hint = /** @type {(inputs: Workout_Logging_Side_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In un esercizio monolaterale, registra ogni lato come una serie a sé.`)
};

/**
* | output |
* | --- |
* | "On a one-sided exercise, log each side as its own set." |
*
* @param {Workout_Logging_Side_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_side_hint = /** @type {((inputs?: Workout_Logging_Side_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Side_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_side_hint(inputs)
	if (locale === "es-419") return es_419_workout_logging_side_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_side_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_side_hint(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_side_hint(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_side_hint(inputs)
	return en_us2_workout_logging_side_hint(inputs)
});
export { workout_logging_side_hint as "workout-logging.side_hint" }